import { render, staticRenderFns } from "./FiltersChips.vue?vue&type=template&id=5c698876&"
import script from "./FiltersChips.vue?vue&type=script&lang=ts&"
export * from "./FiltersChips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports